import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row, Badge } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import Dropzone from 'react-dropzone-uploader';
import { getExamination, addExamination, updateExamination, statusUpdateExamination, deleteExamination, updateExaminationImage, isOpenModal, ModalToggle, isOpenStatusModal, statusToggle } from '../../store/examinationSlice';
import { getTestSeries } from '../../store/testSeriesSlice';
import NoImage from '../../assets/images/noimage.png';

const ExaminationTable = () => {
  const storeVar = useSelector((state) => state.examination);
  const testSeriesStore = useSelector((state) => state.testSeries);
  const dispatch = useDispatch();

  const toggle = () => dispatch(ModalToggle());
  const statusModalToggle = () => dispatch(statusToggle());

  const [stateStatus, setStateStatus] = useState('active');
  const [submit, setSubmit] = useState(false);
  const [typingTimer, setTypingTimer] = useState(null);
  const [testSeriesFilter, setTestSeriesFilter] = useState('');

  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImageFile, setSelectedImageFile] = useState(null);

  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 20,
    offset: 0,
    currentPage: 1,
    status: 'active',
    modalTitle: null,
    editState: false,
    examinationId: '',
    title: '',
    shortDesc: '',
    icon: '',
    testSeriesId: '',
  });

  useEffect(() => {
    dispatch(getExamination(formVar.limit, formVar.offset, formVar.status, formVar.keyword, testSeriesFilter));
    dispatch(getTestSeries(100, 0, 'active', '', ''));
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1);
    setFormVar((prev) => ({ ...prev, currentPage: page, offset }));
    dispatch(getExamination(formVar.limit, offset, formVar.status, formVar.keyword, testSeriesFilter));
  };

  const searchState = (e) => {
    const val = e.target.value;
    setFormVar((prev) => ({ ...prev, keyword: val }));
    clearTimeout(typingTimer);
    const timer = setTimeout(() => {
      dispatch(getExamination(formVar.limit, formVar.offset, formVar.status, val, testSeriesFilter));
    }, 600);
    setTypingTimer(timer);
  };

  const handleStatusFilterChange = (e) => {
    const statusVal = e.target.value;
    setFormVar((prev) => ({ ...prev, status: statusVal }));
    dispatch(getExamination(formVar.limit, formVar.offset, statusVal, formVar.keyword, testSeriesFilter));
  };

  const handleTestSeriesFilterChange = (e) => {
    const tsId = e.target.value;
    setTestSeriesFilter(tsId);
    dispatch(getExamination(formVar.limit, formVar.offset, formVar.status, formVar.keyword, tsId));
  };

  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true));
    setFormVar((prev) => ({
      ...prev,
      editState: true,
      examinationId: data._id,
      modalTitle: 'Edit Examination',
      title: data.title,
      shortDesc: data.shortDesc || '',
      icon: data.icon || '',
      testSeriesId: data.testSeriesId?._id || data.testSeriesId || '',
    }));
  };

  const AddToggleModal = () => {
    dispatch(isOpenModal(true));
    setFormVar((prev) => ({
      ...prev,
      editState: false,
      modalTitle: 'Add Examination',
      title: '',
      shortDesc: '',
      icon: '',
      testSeriesId: testSeriesFilter || (testSeriesStore.testSeriesData?.[0]?._id || ''),
    }));
  };

  const statusToggleModal = (data) => {
    dispatch(isOpenStatusModal(true));
    setStateStatus(data.status);
    setFormVar((prev) => ({ ...prev, examinationId: data._id }));
  };

  const openImageModal = (data) => {
    setFormVar((prev) => ({ ...prev, examinationId: data._id }));
    setSelectedImageFile(null);
    setImageModalOpen(true);
  };

  const handleImageUploadStatus = ({ file }, status) => {
    if (status === 'done') {
      setSelectedImageFile(file);
    } else if (status === 'removed') {
      setSelectedImageFile(null);
    }
  };

  const submitImageUpload = () => {
    if (!selectedImageFile) return;
    dispatch(updateExaminationImage(formVar.examinationId, selectedImageFile));
    setImageModalOpen(false);
  };

  const validateForm = () => {
    if (!formVar.title || !formVar.testSeriesId) {
      return false;
    }
    return true;
  };

  const submitMenu = () => {
    if (!validateForm()) {
      setSubmit(true);
      return;
    }
    setSubmit(false);

    const payload = {
      title: formVar.title,
      shortDesc: formVar.shortDesc,
      icon: formVar.icon,
      testSeriesId: formVar.testSeriesId,
    };

    if (formVar.editState) {
      dispatch(updateExamination(formVar.examinationId, payload));
    } else {
      dispatch(addExamination(payload));
    }
  };

  const submitStatus = () => {
    dispatch(statusUpdateExamination(formVar.examinationId, stateStatus));
  };

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this examination?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        dispatch(deleteExamination(data._id));
      }
    });
  };

  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row className="gy-2">
              <Col md="4">
                <Input
                  className="form-control"
                  placeholder='Search by title...'
                  type="text"
                  value={formVar.keyword}
                  onChange={searchState}
                />
              </Col>
              <Col md="3">
                <Input
                  className="form-control form-control-inverse btn-square"
                  type="select"
                  value={testSeriesFilter}
                  onChange={handleTestSeriesFilterChange}
                >
                  <option value=''>All Courses (Test Series)</option>
                  {testSeriesStore.testSeriesData?.map((ts) => (
                    <option key={ts._id} value={ts._id}>{ts.title}</option>
                  ))}
                </Input>
              </Col>
              <Col md="3">
                <Input
                  className="form-control form-control-inverse btn-square"
                  type="select"
                  value={formVar.status}
                  onChange={handleStatusFilterChange}
                >
                  <option value='active'>ACTIVE</option>
                  <option value='pending'>PENDING</option>
                </Input>
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Examination
                  </Btn>
                </div>
              </Col>
            </Row>
          </CardHeader>

          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Title</th>
                  <th scope='col'>Course</th>
                  <th scope='col'>Short Desc</th>
                  <th scope='col'>Icon / Image</th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.examinationData?.map((item, index) => (
                  <tr key={item._id}>
                    <th scope='row'>{(formVar.currentPage - 1) * formVar.limit + index + 1}</th>
                    <td><div className="font-bold">{item.title}</div></td>
                    <td><Badge color="primary">{item.testSeriesId?.title || 'N/A'}</Badge></td>
                    <td><div className="text-xs text-muted max-w-xs">{item.shortDesc || '—'}</div></td>
                    <td className="w-25">
                      {item.icon ? (
                        item.icon.startsWith('http') ? (
                          <img src={item.icon} alt={item.title} className="w-25 h-auto rounded border" />
                        ) : (
                          <i className={`fa ${item.icon} fa-lg`}></i>
                        )
                      ) : (
                        <img src={NoImage} alt="No Icon" className="w-25 h-auto opacity-50" />
                      )}
                    </td>
                    <td>
                      {item.status === 'active' && <Badge color="success">ACTIVE</Badge>}
                      {item.status === 'pending' && <Badge color="warning">PENDING</Badge>}
                    </td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon p-1 rounded' onClick={() => EditToggleModal(item)}>
                          <i className="fa fa-edit fa-lg"></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer font-success action-icon p-1 rounded' onClick={() => openImageModal(item)}>
                          <i className="fa fa-picture-o fa-lg"></i>
                          <div className="tooltipCustom">Upload Image Icon</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-info action-icon p-1 rounded' onClick={() => statusToggleModal(item)}>
                          <i className="fa fa-toggle-on fa-lg"></i>
                          <div className="tooltipCustom">Status Update</div>
                        </div>
                        <div className='cursor-pointer bg-light-danger font-danger action-icon p-1 rounded' onClick={() => DeleteModel(item)}>
                          <i className="fa fa-trash fa-lg"></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {storeVar.examinationData?.length <= 0 && <Empty />}
        </Card>

        {storeVar.totalExamination > 0 && (
          <Pagination
            currentPage={formVar.currentPage}
            totalItem={storeVar.totalExamination}
            itemsPerPage={formVar.limit}
            showEllipsisAfter={true}
            visiblePageCount={3}
            onPageChange={pageChange}
          />
        )}
      </Col>

      {/* Add/Edit Modal */}
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle}>
        <Form>
          <FormGroup className="mb-3">
            <Label className="col-form-label font-bold">Course *</Label>
            <Input
              className="form-control"
              type="select"
              value={formVar.testSeriesId}
              onChange={(e) => setFormVar((prev) => ({ ...prev, testSeriesId: e.target.value }))}
            >
              <option value=''>— Select Course —</option>
              {testSeriesStore.testSeriesData?.map((ts) => (
                <option key={ts._id} value={ts._id}>{ts.title}</option>
              ))}
            </Input>
            {submit && !formVar.testSeriesId && <span className='d-block font-danger text-xs mt-1'>Course is required</span>}
          </FormGroup>

          <FormGroup className="mb-3">
            <Label className="col-form-label font-bold font-bold">Title *</Label>
            <Input
              className="form-control"
              type="text"
              placeholder='Enter Examination Title'
              value={formVar.title}
              onChange={(e) => setFormVar((prev) => ({ ...prev, title: e.target.value }))}
            />
            {submit && !formVar.title && <span className='d-block font-danger text-xs mt-1'>Title is required</span>}
          </FormGroup>

          <FormGroup className="mb-3">
            <Label className="col-form-label font-bold">Short Description</Label>
            <Input
              className="form-control"
              type="textarea"
              rows={3}
              placeholder='Enter Short Description'
              value={formVar.shortDesc}
              onChange={(e) => setFormVar((prev) => ({ ...prev, shortDesc: e.target.value }))}
            />
          </FormGroup>

          <FormGroup className="mb-3">
            <Label className="col-form-label font-bold">Icon CDN Link</Label>
            <Input
              className="form-control"
              type="text"
              placeholder='Enter CDN Link (e.g. https://cdn.example.com/icon.png)'
              value={formVar.icon}
              onChange={(e) => setFormVar((prev) => ({ ...prev, icon: e.target.value }))}
            />
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }}>Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>

      {/* Upload Image Icon Modal */}
      <CommonModal isOpen={imageModalOpen} title="Upload Examination Image Icon" toggler={() => setImageModalOpen(false)}>
        <Dropzone
          maxFiles={1}
          multiple={false}
          canCancel={false}
          inputContent="Drop or click to upload icon image"
          onChangeStatus={handleImageUploadStatus}
          accept="image/*"
        />
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: () => setImageModalOpen(false) }}>Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitImageUpload }}>Upload Icon</Btn>
        </ModalFooter>
      </CommonModal>

      {/* Status Modal */}
      <CommonModal isOpen={storeVar.isStatusOpenModal} title={"Update Examination Status"} toggler={statusModalToggle}>
        <Form className="p-2">
          <FormGroup tag="fieldset">
            <div className="d-flex gap-4">
              <Label check>
                <Input
                  type="radio"
                  name="statusRadio"
                  value="active"
                  checked={stateStatus === 'active'}
                  onChange={(e) => setStateStatus(e.target.value)}
                />{' '}
                Active
              </Label>
              <Label check>
                <Input
                  type="radio"
                  name="statusRadio"
                  value="pending"
                  checked={stateStatus === 'pending'}
                  onChange={(e) => setStateStatus(e.target.value)}
                />{' '}
                Pending
              </Label>
            </div>
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: statusModalToggle }}>Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitStatus }}>Update Status</Btn>
        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default ExaminationTable;

